import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { ExportRequest } from '../domain/dtos/export-request'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class GetExportRequest {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(id: string): Promise<ExportRequest> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.FUNCTIONS_URL}/exportRequestGet/pt`,
      body: { data: { id } },
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data.result
    }

    throw new GeneralError()
  }
}
